import { render, staticRenderFns } from "./BuilderTranslation.vue?vue&type=template&id=4eaca05f&scoped=true&"
import script from "./BuilderTranslation.vue?vue&type=script&lang=js&"
export * from "./BuilderTranslation.vue?vue&type=script&lang=js&"
import style0 from "./BuilderTranslation.vue?vue&type=style&index=0&id=4eaca05f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaca05f",
  null
  
)

export default component.exports